import React from 'react';
import gabmicLogo from '../../assets/gabmic-logo.png';

const Footer: React.FC = () => {
  const footerStyle: React.CSSProperties = {
    padding: '4rem 2rem',
    borderTop: '1px solid var(--border-color)',
    backgroundColor: 'var(--bg-background)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2rem',
  };

  const linkGroupStyle: React.CSSProperties = {
    display: 'flex',
    gap: '2rem',
    flexWrap: 'wrap',
    justifyContent: 'center',
  };

  const linkStyle: React.CSSProperties = {
    color: 'var(--text-secondary)',
    fontSize: '0.875rem',
    textTransform: 'uppercase',
    letterSpacing: 0,
    fontFamily: 'var(--font-mono, "JetBrains Mono", monospace)',
  };

  return (
    <footer style={footerStyle}>
      <img src={gabmicLogo} alt="GabMic" style={{ height: '28px', width: 'auto' }} />
      
      <div style={linkGroupStyle}>
        <a href="#" style={linkStyle}>Privacy Policy</a>
        <a href="#" style={linkStyle}>Terms of Service</a>
        <a href="#" style={linkStyle}>Contact Support</a>
      </div>
      
      <p style={{ fontSize: '0.875rem', color: 'var(--border-color)', margin: 0 }}>
        &copy; {new Date().getFullYear()} GabMic AI. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
